<template>
  <b-container
    fluid
    class="admin-view-container"
  >
    <b-nav
      pills
      align="right"
    >
      <b-navbar-brand :to="{name:'admin-home'}">
        <img :src="require('@/assets/Fronttest/logo_w.png')" />
      </b-navbar-brand>

      <li class="admin">
        <b>管理員: {{ user.name }}</b>
      </li>
      <b-nav-item :to="{name:'admin-home'}">產品總覽</b-nav-item>
      <b-nav-item :to="{name:'admin-add'}">產品上架</b-nav-item>
      <b-nav-item :to="{name:'admin-add-news'}">發布消息</b-nav-item>
      <b-nav-item :to="{name:'admin-category'}">分類管理</b-nav-item>
      <b-nav-item :to="{name:'admin-requests'}">客戶訊息</b-nav-item>
      <b-nav-item
        v-if="user.authority==='manager'"
        :to="{name:'admin-mission'}"
      >
        任務紀錄
        <div v-if="pendingMissionLength">{{ pendingMissionLength }}</div>
      </b-nav-item>
      <b-nav-item
        v-if="user.authority==='manager'"
        :to="{name:'admin-auth'}"
      >
        帳號管理
      </b-nav-item>

      <b-nav-item @click="logout">
        登出
        <b-icon-arrow-bar-right />
      </b-nav-item>
    </b-nav>

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view v-if="!loading" />
      <b-spinner v-else />
    </transition>
  </b-container>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import firebase from "../store/modules/firebase";

  export default {
    created() {
      this.cleanAuthStateChanged = firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$store.dispatch("login/queryUser", { uid: user.uid });
          this.$store.dispatch("backend/fetchProducts");
          this.$store.dispatch("backend/fetchNews");
          this.$store.dispatch("backend/fetchNewsCategories");
          this.$store.dispatch("backend/fetchMissions");
          this.$store.dispatch("backend/fetchCategories");
          this.$store.dispatch("backend/fetchContactRequests");
          this.loading = false;
        } else {
          this.$router.replace({ name: "login" });
        }
      });
    },
    beforeDestroy() {
      this.cleanAuthStateChanged();
    },
    data() {
      return {
        loading: true,
        athor: "superviser",
      };
    },
    computed: {
      ...mapState("backend", [
        "AdminName",
        "Authority",
        "missionChange",
        "productChange",
      ]),
      ...mapState("login", ["account", "user"]),
      ...mapGetters("backend", ["pendingMissionLength"]),
    },
    methods: {
      ...mapActions("backend", ["fetchMissions", "fetchProducts", "fetchNews"]),
      ...mapActions("login", ["accountLogout"]),

      logout: function () {
        this.accountLogout();
        this.$router.push({ name: "login" });
      },
    },
    watch: {
      missionChange: function () {
        this.fetchMissions();
      },
      productChange: function () {
        this.fetchProducts();
      },
      newsChange: function () {
        this.fetchNews();
      },
      user: function () {
        if (this.user.isArchive) {
          this.$router.replace({ name: "login" });
        }
      },
    },
  };
</script>

<style>
  .fade-enter {
    opacity: 0;
    transition: 1s;
  }

  .fade-leave {
    opacity: 1;
  }
</style>
